import { MenuItem } from 'primeng/api';

/**
 * Main sidebar menu items for the Kanzi Dashboards application.
 * The app is a tenant admin panel, so the entry point is the tenants list
 * (dashboards are managed inside each tenant).
 * Each item uses i18n keys for its label and a PrimeIcons icon.
 * The `automationId` maps to a permission code used to filter items by role.
 * @type {MenuItem[]}
 */
export const ItemsMenu: MenuItem[] = [
  {
    automationId: 'DASHBOARDS',
    label: 'menu_main.tenants',
    icon: 'pi pi-fw pi-building',
    visible: true,
    routerLink: 'dashboards',
  },
];

/**
 * Quick-access options shown in the main landing view (home).
 * @type {MenuItem[]}
 */
export const ItemsLayoutMainOptions: MenuItem[] = [
  {
    automationId: 'DASHBOARDS',
    label: 'menu_main.tenants',
    icon: 'pi pi-fw pi-building',
    routerLink: 'dashboards',
    tooltip: 'tenants.description',
  },
];
